import { Service } from '../../../store/types';
import { ActionType } from '../../actionTypes';
import { createApiRequestAction } from '../../helpers';
import { variableStats as variableStatsSchema } from '../../schema';

export const fetchLatestVariableStats = (variableName: string) =>
  createApiRequestAction(ActionType.FETCH_LATEST_VARIABLESTATS_REQUESTED, {
    request: {
      method: 'GET',
      service: Service.PLANNER,
      url: `/v2/variables/${variableName}/stats`,
      normalizr: {
        schema: variableStatsSchema,
      },
      responseTypes: {
        started: ActionType.FETCH_LATEST_VARIABLESTATS_STARTED,
        succeeded: ActionType.FETCH_LATEST_VARIABLESTATS_SUCCEEDED,
        failed: ActionType.FETCH_LATEST_VARIABLESTATS_FAILED,
      },
    },
  });
